export const ReduceIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2498 1.66663C16.8024 1.66663 17.3323 1.88612 17.723 2.27682C18.1137 2.66752 18.3332 3.19742 18.3332 3.74996V16.25C18.3332 16.8025 18.1137 17.3324 17.723 17.7231C17.3323 18.1138 16.8024 18.3333 16.2498 18.3333H3.74984C3.1973 18.3333 2.6674 18.1138 2.2767 17.7231C1.886 17.3324 1.6665 16.8025 1.6665 16.25V3.74996C1.6665 3.19742 1.886 2.66752 2.2767 2.27682C2.6674 1.88612 3.1973 1.66663 3.74984 1.66663H16.2498ZM8.33317 3.33329H4.99984C4.55781 3.33329 4.13389 3.50889 3.82133 3.82145C3.50877 4.13401 3.33317 4.55793 3.33317 4.99996V15C3.33317 15.442 3.50877 15.8659 3.82133 16.1785C4.13389 16.491 4.55781 16.6666 4.99984 16.6666H8.33317C8.7752 16.6666 9.19912 16.491 9.51168 16.1785C9.82424 15.8659 9.99984 15.442 9.99984 15V4.99996C9.99984 4.55793 9.82424 4.13401 9.51168 3.82145C9.19912 3.50889 8.7752 3.33329 8.33317 3.33329Z"
        fill="#636E72"
      />
    </svg>
  );
};
